/**
 * StockStep Component
 * Step 4: Stock and cost information (optional)
 *
 * @version 2025.1.0
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Grid,
  TextField,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { EpcFormData } from '../../../../../types/epc';
import { StockStepProps } from '../EPCFormWizard.types';
import { CurrencyInput } from '../../../../../components/forms';

export const StockStep: React.FC<StockStepProps> = ({
  disabled = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<EpcFormData>();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Informe os dados de estoque e custos do EPC.
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Todos os campos desta etapa são opcionais. Clique em "Salvar EPC" para finalizar.
      </Alert>

      <Grid container spacing={3}>
        {/* Quantidade */}
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <Controller
            name="quantidade"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                value={field.value ?? ''}
                label="Quantidade Instalada"
                fullWidth
                type="number"
                error={Boolean(errors.quantidade)}
                helperText={errors.quantidade?.message}
                disabled={disabled}
              />
            )}
          />
        </Grid>

        {/* Unidade */}
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <Controller
            name="unidade"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Unidade de Medida"
                fullWidth
                error={Boolean(errors.unidade)}
                helperText={errors.unidade?.message || 'Ex: unidade, metro, m²'}
                disabled={disabled}
              />
            )}
          />
        </Grid>

        {/* Custo */}
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <Controller
            name="custo"
            control={control}
            render={({ field }) => (
              <CurrencyInput
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                label="Custo Unitário"
                fullWidth
                error={Boolean(errors.custo)}
                helperText={errors.custo?.message}
                disabled={disabled}
              />
            )}
          />
        </Grid>

        {/* Observação */}
        <Grid size={12}>
          <Controller
            name="observacao"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Observações"
                fullWidth
                multiline
                rows={4}
                error={Boolean(errors.observacao)}
                helperText={errors.observacao?.message}
                disabled={disabled}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StockStep;
